
import { Component, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TemplateDTO } from '../../api/plyca-dtos';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { generateRandomIdentifier } from '../../ui.service';
import { HelpService } from '../../components/common/help/help.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

export class TemplateDTOModal {
  templates: TemplateDTO[];
  constructor(templates: TemplateDTO[]) {
    this.templates = templates;
  }
}
@Component({
  selector: 'templateModal',
  templateUrl: 'basicDocumentModal.template.html'
})
export class templateModalComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  context: TemplateDTOModal;

  // PARAM: indica el buscador a utilizar
  templates: TemplateDTO[];
  template: TemplateDTO;

  public formGroup: FormGroup;
  windowHash: string;

  constructor(
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    protected waitService: WaitLoadingService,
    public helpService: HelpService,
    @Optional() public ref: DynamicDialogRef,
    @Optional() public dialogConfig: DynamicDialogConfig) {

    super();
    this.context = this.dialogConfig['context'];
    this.templates = this.dialogConfig['context']['templates'];
    this.windowHash = generateRandomIdentifier();
  }



  ngAfterContentInit(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn btn-primary',
      true, this.windowHash
    ), success => {
      this.accept();
    });

    this.subscribe(this.headerActionsService.addWindowAction(
      'General.cancel',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.cancel();
    });
    this.waitService.cancelWaiting();
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  isLoaded(): boolean {
    return this.templates !== undefined;
  }

  accept(): void {
    this.ref.close(this.template);
  }

  cancel(): void {
    this.ref.close();
  }

  selectTemplate(template: TemplateDTO): void {
    this.template = template;

  }



}
